export const dadosIniciais = {
  anamnese: "",
  sinaisSintomas: [],
  sinaisSintomasOutro: "",
  ventilacaoNaoInvasivaBIPAP: "",
  bipapDataInicio: "",
  bipapDuracao: "",
  traquestomia: "",
  traqueostomiaDataInicio: "",
  traqueostomiaProcedimento: "",
  gastrostomia: "",
  gastrostomiaDataInicio: "",
  sondaNasogastrica: "",
  sondaNasogastricaDataInicio: "",
  coughAssist: "",
  tecnologiaComunicacao: "",
  assistenciaDomiciliar: "",
  multidisciplinar: "",
  multidisciplinarTipo: [],
  usoCadeiraDeRodas: "",
  tipoProcedimento: "",
  frequenciaCardiaca: "",
  pressaoArterial: "",
  pesoAtual: "",
  perdaDePeso: "",
  fluenciaVerbal: "",
  rastreioComportamental: "",
  apatia: "",
  statusCognitivo: "",
  reflexoFotomotor: "",
  papilederma: "",
  motricidadeOcular: "",
  ptosePalpebral: "",
  reflexoNauseoso: "",
  musculaturaFacial: [],
  masseter: "",
  linguaMovimentacao: "",
  linguaAtrofia: "",
  linguaFasciculacao: "",
  veloPalatino: "",
  disartria: "",
  anartria: "",
  abducaoCoxasDireita: "",
  abducaoCoxasEsquerda: "",
  flexaoQuadrisDireita: "",
  flexaoQuadrisEsquerda: "",
  extensaoJoelhosDireita: "",
  extensaoJoelhosEsquerda: "",
  flexaoJoelhosDireita: "",
  flexaoJoelhosEsquerda: "",
  dorsiflexaoJoelhosDireita: "",
  dorsiflexaoJoelhosEsquerda: "",
  inversaoPesDireita: "",
  inversaoPesEsquerda: "",
  flexaoPlanarPesDireita: "",
  flexaoPlanarPesEsquerda: "",
  abducaoOmbrosDireita: "",
  abducaoOmbrosEsquerda: "",
  flexaoCotovelosDireita: "",
  flexaoCotovelosEsquerda: "",
  extensaoCotovelosDireita: "",
  extensaoCotovelosEsquerda: "",
  flexaoPunhosDireita: "",
  flexaoPunhosEsquerda: "",
  extensaoDedosDireita: "",
  extensaoDedosEsquerda: "",
  abducaoDedosDireita: "",
  abducaoDedosEsquerda: "",
  abducaoPolegarDireita: "",
  abducaoPolegarEsquerda: "",
  primeiroInterosseoDorsalDireita: "",
  primeiroInterosseoDorsalEsquerda: "",
  MIDProximal: "",
  MIDDistal: "",
  MIEProximal: "",
  MIEDistal: "",
  MSDProximal: "",
  MSDDistal: "",
  MSEProximal: "",
  MSEDistal: "",
  fasciculacoesMotor: "",
  fasciculacoesMotorOnde: [],
  MSD: "",
  MSE: "",
  MID: "",
  MIE: "",
  reflexoBicipitalDireita: "",
  reflexoBicipitalEsquerda: "",
  reflexoTricipitalDireita: "",
  reflexoTricipitalEsquerda: "",
  reflexoPatelarDireita: "",
  reflexoPatelarEsquerda: "",
  reflexoAquileuDireita: "",
  reflexoAquileuEsquerda: "",
  reflexoPeitoralDireita: "",
  reflexoPeitoralEsquerda: "",
  reflexoCutaneoDireita: "",
  reflexoCutaneoEsquerda: "",
  sinalDeHoffmannDireita: "",
  sinalDeHoffmannEsquerda: "",
  tremor: "",
  bradicinesia: "",
  ataxia: "",
  parestesias: "",
  disestesias: "",
  alodinia: "",
  MIDProximalVibratoria: "",
  MIDProximalCinetPost: "",
  MIDProximalTactil: "",
  MIDProximalDor: "",
  MIDDistalVibratoria: "",
  MIDDistalCinetPost: "",
  MIDDistalTactil: "",
  MIDDistalDor: "",
  MIEProximalVibratoria: "",
  MIEProximalCinetPost: "",
  MIEProximalTactil: "",
  MIEProximalDor: "",
  MIEDistalVibratoria: "",
  MIEDistalCinetPost: "",
  MIEDistalTactil: "",
  MIEDistalDor: "",
  MSDProximalVibratoria: "",
  MSDProximalCinetPost: "",
  MSDProximalTactil: "",
  MSDProximalDor: "",
  MSDDistalVibratoria: "",
  MSDDistalCinetPost: "",
  MSDDistalTactil: "",
  MSDDistalDor: "",
  MSEProximalVibratoria: "",
  MSEProximalCinetPost: "",
  MSEProximalTactil: "",
  MSEProximalDor: "",
  MSEDistalVibratoria: "",
  MSEDistalCinetPost: "",
  MSEDistalTactil: "",
  MSEDistalDor: "",
  disfuncaoAutonomica: "",
  tipoDisfuncao: [],
  disfuncaoAutonomicaOutra: "",
  examesPredefinidos: "",
  diagnosticoEhELA: "",
  dataDiagnosticoELA: "",
  classificacaoKingsCollege: "",
  escalaFuncional: "",
  velocidadeDeProgressao: "",
  causaELA: "",
  localDeInicio: "",
  fenotipoDeInicio: "",
  observacaoELA: "",
  sugestaoDiagnostico: "",
  examesPredefinidosSelect: [],
  examesPredefinidosExamesEProcedimentos: [],
  outrosExamesLaboratoriais: [],
  examesLaboratoriaisObservacao: "",
  solicitacaoOutrosExames: [],
  condutaConclusaoEncaminhamentos: "",

  capacidadeVitalForcada: "",
  pressaoInspiratoria: "",
  pressaoExpiratoria: "",
  pressaoNasalInspiratoria: "",
};
